import { isMobile } from "react-device-detect";

import DropDownListMobile from "./mobile";
import { Props } from "./types";
import DropDownListWeb from "./web";

export function DropDownList(props: Props) {
	const defaultProps = {
		valueProp: "value",
		textProp: "label",
		loaded: true,
		highlightedValues: new Set<any>(),
	} as Props;
	if (isMobile) return <DropDownListMobile {...defaultProps} {...props} />;
	return <DropDownListWeb {...defaultProps} {...props} />;
}

export * from "./async";
